import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataHistoric = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "data-his-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc11 {\n        fill: #0573A9;\n      }\n    " }) }), /* @__PURE__ */ _jsxs("g", {
		id: "data-icon-historic",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "secc11",
				d: "M2.00545,12.91917h4.78747c-.18456-.34142-.32189-.70632-.40824-1.0847H2.00545c-.49014,0-.88748-.39734-.88748-.88748V2.07218c0-.49014.39734-.88748.88748-.88748h8.87481c.49014,0,.88748.39734.88748.88748v4.63462c.38052.1016.74544.25453,1.0847.45459V2.07218c0-1.08921-.88297-1.97218-1.97218-1.97218H2.00545c-.91343.00222-1.70581.63139-1.91499,1.52055-.03666.14779-.05586.29937-.05719.45163v8.87481c.00007.13251.01362.26467.04043.39444.18739.91802.99481,1.57747,1.93175,1.57774"
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "secc11",
				x: 2.59611,
				y: 2.66393,
				width: 3.2541,
				height: 3.2541
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "secc11",
				x: 2.59611,
				y: 7.10134,
				width: 3.2541,
				height: 3.2541
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "secc11",
				x: 7.03352,
				y: 2.66393,
				width: 3.2541,
				height: 3.2541
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "secc11",
				d: "M7.03451,8.46007c.39224-.56647.91295-1.0321,1.51957-1.35883h-1.51957v1.35883Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "secc11",
				d: "M12.04287,11.08899l-1.00483-.42994v-1.06498c.00031-.21784-.17604-.39468-.39388-.39499s-.39468.17604-.39499.39388v1.32444h0c.00117.00831.00281.01654.00493.02465.00162.04278.00993.08504.02465.12523.01138.022.02492.04281.04043.06212.02939.06065.08039.10814.14298.13312.00986.00493.01578.01381.02662.01775l1.24445.53249c.04881.0214.10152.03248.15482.03254.21784.00143.39558-.17401.39701-.39184.00105-.15996-.09462-.30472-.2422-.36646"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "secc11",
				d: "M10.64755,14.2287c-1.83313,0-3.31918-1.48605-3.31918-3.31918s1.48605-3.31918,3.31918-3.31918,3.31918,1.48605,3.31918,3.31918h0c-.00217,1.83223-1.48695,3.31701-3.31918,3.31918M10.64755,8.57643c-1.28853,0-2.33309,1.04456-2.33309,2.33309s1.04456,2.33309,2.33309,2.33309c1.28853,0,2.33309-1.04456,2.33309-2.33309h0c-.0038-1.28631-1.04677-2.32752-2.33309-2.32915"
			})
		]
	})]
});
export default SvgDataHistoric;
